import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async calculaRepassePeriodo(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("repasse/access/calcularPeriodo", dados);
        return data;
    },
    async getRepasse(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        const requisicao = {
            ...dados,
            pagina: dados.pagina ?? 1,
            quantidadePorPagina: dados.quantidadePorPagina ?? 25
        };
        ApiService.setHeader();
        const { data } = await ApiService.post("repasse/access/listar", requisicao);
        return data;
    },
    async calculaRepasse(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.post("repasse/access/atualizarRepasse", dados);
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
